import { Tag } from 'antd'

import { HivAnamnesisCaseStatus } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status?: HivAnamnesisCaseStatus
}

const HivAnamnesisStatusMap = {
  [HivAnamnesisCaseStatus.DRAFT]: 'warning',
  [HivAnamnesisCaseStatus.COMPLETED]: 'success'
}

export const HivAnamnesisStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  if (!status) return '-'

  return (
    <Tag color={HivAnamnesisStatusMap[status]}>
      {t(`hiv_anamnesis.status.${status}`)}
    </Tag>
  )
}
